import React, { createContext, useContext, useRef } from "react";

type PageContextType = {
  register: () => number;
  getTotalPages: () => number;
};

const PageNumberContext = createContext<PageContextType | null>(null);

export const usePageNumberContext = () => {
  const ctx = useContext(PageNumberContext);
  if (!ctx) throw new Error("PageNumber must be used within PageNumberProvider");
  return ctx;
};

export const PageNumberProvider = ({ children }: { children: React.ReactNode }) => {
  const registeredPages = useRef<number[]>([]);

  const register = () => {
    const pageNumber = registeredPages.current.length + 1;
    registeredPages.current.push(pageNumber);
    return pageNumber;
  };

  const getTotalPages = () => registeredPages.current.length;

  return (
    <PageNumberContext.Provider value={{ register, getTotalPages }}>
      {children}
    </PageNumberContext.Provider>
  );
};
